import { useDispatch } from 'react-redux'
import { trackInternalEvent } from '@rio/tracking'
import { actions, selectors } from 'builder/modules/resumeEditor'
import { EditorPanelType } from 'builder/modules/generalEditor'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { useI18n } from 'builder/hooks/useI18n'
import { useStepByStepFeature } from '../StepByStepFlow/hooks/useStepByStepFeature'

const TRANSLATION = 'builder.resume_editor.tab_names'

export const useTabNavigation = () => {
  const dispatch = useDispatch()
  const editorPanelType = useTypedSelector(selectors.editorPanelType)
  const autoTailoringFromPublicJobBoard = useTypedSelector(
    selectors.autoTailoringFromPublicJobBoard,
  )
  const { isRbpStepFlowActive } = useStepByStepFeature()
  const { i18n } = useI18n()

  const handleTabChange = (type: EditorPanelType) => {
    dispatch(actions.setEditorPanelType(type))
    trackInternalEvent('switch_resume_editor_tab', {
      tab: type,
    })
  }

  const getTabItems = () => [
    { id: 'editor' as const, text: i18n.t(`${TRANSLATION}.editor`) },
    { id: 'customization' as const, text: i18n.t(`${TRANSLATION}.customization`) },
    ...(isRbpStepFlowActive || autoTailoringFromPublicJobBoard.enabled
      ? []
      : [
          { id: 'ai_review' as const, text: i18n.t(`${TRANSLATION}.ai_review`) },
          { id: 'tailoring' as const, text: i18n.t(`${TRANSLATION}.tailoring`) },
        ]),
  ]

  return { handleTabChange, getTabItems, editorPanelType }
}

export const useResumeNameChange = () => {
  const dispatch = useDispatch()

  const handleResumeNameChange = (name: string) => {
    dispatch(actions.updateSimpleField({ name: 'name', value: name, debounce: true }))
    trackInternalEvent('rename_resume')
  }

  return { handleResumeNameChange }
}
